import { type TournamentEngineMappedConstantItemInterface } from 'typedefs/avoidance';

export const avoidanceConstants = {
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE_3: 'Zip code (3 digits)',
  ZIP_CODE_4: 'Zip code (4 digits)',
  ZIP_CODE_5: 'Zip code (5 digits)',
  COUNTRY: 'Country',
  SECTION: 'Section',
  DISTRICT: 'District',
  DOUBLES_TEAM: 'Doubles Team',
  TEAM: 'Team',
  MAPPED_PARTICIPANT_CITY: 'person.addresses.city',
  MAPPED_INDIVIDUAL_PARTICIPANT_CITY: 'individualParticipants.person.addresses.city',
  MAPPED_PARTICIPANT_STATE: 'person.addresses.state',
  MAPPED_INDIVIDUAL_PARTICIPANT_STATE: 'individualParticipants.person.addresses.state',
  MAPPED_PARTICIPANT_POSTAL_CODE: 'person.addresses.postalCode',
  MAPPED_INDIVIDUAL_PARTICIPANT_POSTAL_CODE: 'individualParticipants.person.addresses.postalCode',
  MAPPED_PARTICIPANT_COUNTRY: 'person.addresses.country',
  MAPPED_INDIVIDUAL_PARTICIPANT_COUNTRY: 'individualParticipants.person.addresses.country',
  MAPPED_PARTICIPANT_SECTION: 'person._ustaSection.code',
  MAPPED_INDIVIDUAL_PARTICIPANT_SECTION: 'individualParticipants.person._ustaSection.code',
  MAPPED_PARTICIPANT_DISTRICT: 'person._ustaDistrict.code',
  MAPPED_INDIVIDUAL_PARTICIPANT_DISTRICT: 'individualParticipants.person._ustaDistrict.code',
  MAPPED_PARTICIPANT_DOUBLE_TEAM: 'pairParticipants',
  MAPPED_PARTICIPANT_GROUP: 'groupParticipants',
};
export const avoidanceConstantsArray = [
  avoidanceConstants.CITY,
  avoidanceConstants.STATE,
  avoidanceConstants.ZIP_CODE_3,
  avoidanceConstants.ZIP_CODE_4,
  avoidanceConstants.ZIP_CODE_5,
  avoidanceConstants.COUNTRY,
  avoidanceConstants.SECTION,
  avoidanceConstants.DISTRICT,
  avoidanceConstants.DOUBLES_TEAM,
  avoidanceConstants.TEAM,
];

export const tournamentEngineMappedConstants = {
  [avoidanceConstants.CITY]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_CITY },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_CITY },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.STATE]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_STATE },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_STATE },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.ZIP_CODE_3]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_POSTAL_CODE, significantCharacters: 3 },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_POSTAL_CODE, significantCharacters: 3 },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.ZIP_CODE_4]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_POSTAL_CODE, significantCharacters: 4 },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_POSTAL_CODE, significantCharacters: 4 },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.ZIP_CODE_5]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_POSTAL_CODE, significantCharacters: 5 },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_POSTAL_CODE, significantCharacters: 5 },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.COUNTRY]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_COUNTRY },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_COUNTRY },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.SECTION]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_SECTION },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_SECTION },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.DISTRICT]: [
    { key: avoidanceConstants.MAPPED_PARTICIPANT_DISTRICT },
    { key: avoidanceConstants.MAPPED_INDIVIDUAL_PARTICIPANT_DISTRICT },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.DOUBLES_TEAM]: [
    { directive: avoidanceConstants.MAPPED_PARTICIPANT_DOUBLE_TEAM },
  ] as TournamentEngineMappedConstantItemInterface[],
  [avoidanceConstants.TEAM]: [
    { directive: avoidanceConstants.MAPPED_PARTICIPANT_GROUP },
  ] as TournamentEngineMappedConstantItemInterface[],
};
